import React, { useCallback, useContext } from 'react';
import useTranslations from '../../../hooks/useTranslations';
import { FormContext, useField } from '../FormContext';
import DropDownFieldView from '../view/DropDownFieldView';

const DropDownFieldEngine = ({
  internalId,
  value,
  setValue,
  required,
  readOnly,
  options = [],
  ...fieldProps // for future development, know whe have this
}) => {
  const { onFormBuilderDefaultValueSaved = () => {} } = useContext(FormContext);
  const t = useTranslations();
  const validator = useCallback(
    value => {
      value = value ? value : '';
      let error = '';

      if (required && value.trim() === '') {
        error = t('forms.fields.error.required');
      }

      return error;
    },
    [required]
  );

  const onChange = value => {
    setValue(value);
    var event = new Event('change', { bubbles: true });

    // Dispatch it.
    if (internalId) {
      document
        .querySelector('[field-id=' + internalId + ']')
        .dispatchEvent(event);
    }

    onFormBuilderDefaultValueSaved(value);
  };

  useField(internalId, validator);

  const viewProps = {
    onChange,
    internalId,
    value,
    setValue,
    required,
    readOnly,
    options: [
      {
        value: null,
        text: 'forms.field.dropdown.placeholder',
        'data-testid': `dropdown-${internalId}-clear`
      },
      ...options.map(o => ({
        value: o,
        text: o,
        'data-testid': `dropdown-${internalId}-${o}`
      }))
    ]
  };

  return <DropDownFieldView {...viewProps} />;
};

export default DropDownFieldEngine;
